import { useEffect } from 'react';
import { EventName } from '../../tracking/EventName';
import { getTracker } from '../../tracking/getTracker';
import { getIsInCam0001VariantA } from './cam0001Utils';
let hasExposureBeenTrackedForCAM0001Cache = false;
export function getHasExposureBeenTrackedForCAM0001() {
  return hasExposureBeenTrackedForCAM0001Cache;
}
export function setHasExposureBeenTrackedForCAM0001() {
  hasExposureBeenTrackedForCAM0001Cache = true;
}
export function resetExposureForCAM0001() {
  hasExposureBeenTrackedForCAM0001Cache = false;
}
export const trackCam0001ExperimentExposure = () => {
  setHasExposureBeenTrackedForCAM0001();
  getTracker().track(EventName.ExperimentExposure, {
    action: 'cam-0001-group-variant_a'
  }, true);
};
export const useTrackCAM0001Exposure = () => {
  const exposureHasBeenTracked = getHasExposureBeenTrackedForCAM0001();
  const isInCam0001VariantA = getIsInCam0001VariantA();
  useEffect(() => {
    if (isInCam0001VariantA && !exposureHasBeenTracked) {
      trackCam0001ExperimentExposure();
    }
  });
};